import { useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { publicApi } from '../../../../services/api';
import { WheelData } from '../../../../types';
import toast from 'react-hot-toast';

/**
 * Hook para carregar dados da roda
 */
export const useWheelData = () => {
  const { slug, companySlug } = useParams<{ slug: string, companySlug: string }>();
  const [wheelData, setWheelData] = useState<WheelData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const loadWheelData = useCallback(async () => {
    if (!slug || !companySlug) return;

    try {
      setIsLoading(true);
      const data = await publicApi.getWheelData(companySlug, slug);
      setWheelData(data);

      if (!data.stats.has_available_prizes) {
        toast.error('Esta roda não possui prêmios disponíveis no momento');
      }
    } catch (error: any) {
      toast.error(error.error || 'Sorteio não encontrado');
    } finally {
      setIsLoading(false);
    }
  }, [slug, companySlug]);

  return {
    wheelData,
    isLoading,
    loadWheelData,
    slug,
    companySlug
  };
};
